import type { ExtractionRun, ExtractionRunStatus } from '@/services/api/cases'

export type StatusFilter = 'all' | 'running' | 'complete' | 'partial' | 'failed'

export function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'Just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  return new Date(dateStr).toLocaleDateString()
}

export function formatDurationMs(ms?: number | null): string {
  if (ms == null) return '—'
  if (ms < 1000) return `${ms}ms`
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`
  const m = Math.floor(ms / 60_000)
  const s = Math.round((ms % 60_000) / 1000)
  if (m < 60) return s ? `${m}m ${s}s` : `${m}m`
  const h = Math.floor(m / 60)
  return `${h}h ${m % 60}m`
}

export function etaLabel(run: ExtractionRun): string {
  if (run.eta_ms != null && run.eta_ms > 0) return formatDurationMs(run.eta_ms)
  switch (run.eta_reason) {
    case 'warming_up':
      return 'warming up…'
    case 'pending':
      return 'queued'
    case 'estimating':
      return 'estimating…'
    default:
      return '—'
  }
}

export function statusAccent(status: ExtractionRunStatus): string {
  switch (status) {
    case 'running':
      return 'bg-primary'
    case 'failed':
      return 'bg-destructive'
    case 'completed_with_errors':
      return 'bg-warning'
    default:
      return 'bg-success'
  }
}

export function statusFilterOf(run: ExtractionRun): StatusFilter {
  if (run.status === 'running') return 'running'
  if (run.status === 'failed') return 'failed'
  if (run.status === 'completed_with_errors') return 'partial'
  return 'complete'
}
